import { useEffect } from 'react';
import { useAnimate } from 'motion/react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import LogoLoader from '@/assets/images/0-latelier-top-secret.json';

interface Props {
  onComplete: () => void;
}

export const Div0 = ({ onComplete }: Props) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const enterAnimation = async () => {
      // initial state, instant
      await animate(scope.current, { opacity: 0 }, { duration: 0, ease: 'easeInOut' });

      // actual animation
      await animate(scope.current, { opacity: 1 }, { duration: 1, ease: 'easeInOut' });
    };

    void enterAnimation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const exitAnimation = () => {
    void animate(scope.current, { opacity: 0 }, { duration: 1, ease: 'easeInOut' }).then(onComplete);
  };

  return (
    <div ref={scope} className="w-full md:w-1/2">
      <DotLottieReact data={LogoLoader} autoplay dotLottieRefCallback={dotLottie => dotLottie?.addEventListener('complete', exitAnimation)} />
    </div>
  );
};
